// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"607":"3f8eaedebdd7309b","813":"598064aff31bcbdb"}[chunkId] + ".js";
};